import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";
import { Link } from "react-router-dom";

import APButton from "./APButton";
import APIcon, { APIconName } from "./APIcon";

type APMenuButtonProps = {
  text: string;
  items: APMenuItem[];
  icon?: APIconName;
  endAdornment?: React.ReactNode;
};

export type APMenuItem = {
  id: string;
  text: string;
  icon?: APIconName;
  endAdornment?: React.ReactNode;
  to?: string;
  onClick?: () => void;
};

const APMenuButton = ({ text, items, icon }: APMenuButtonProps) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const renderMenuItem = (menuItem: APMenuItem) => {
    const renderedMenuItem = (
      <MenuItem
        key={menuItem.id}
        onClick={() => {
          menuItem.onClick?.();
          handleClose();
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          justifyContent="flex-start"
        >
          <Box display="flex">
            {menuItem.icon && <APIcon name={menuItem.icon} color="primary" />}
          </Box>

          {menuItem.text}

          <Box display="flex">{menuItem.endAdornment}</Box>
        </Box>
      </MenuItem>
    );

    return menuItem.to ? (
      <Link key={menuItem.id} to={menuItem.to}>
        {renderedMenuItem}
      </Link>
    ) : (
      renderedMenuItem
    );
  };

  return (
    <Box sx={{ position: "relative" }}>
      <APButton
        text={text}
        variant="contained"
        onClick={handleOpen}
        icon={icon}
        endIcon="arrow-down"
      />
      <Menu
        open={open}
        onClose={handleClose}
        slotProps={{
          root: {
            style: {
              position: "absolute",
              width: "100%",
              height: "100%",
              top: 0,
              left: 0,
            },
          },
          paper: {
            sx: {
              minWidth: "150px",
              maxWidth: "none !important",
              position: "absolute !important",
              top: "100% !important",

              // RIGHT ALIGNMENT OVERRIDES
              left: "auto !important", // Disables the left-edge pinning
              right: "0px !important", // Pins the right edge to the right side
              transform: "none !important",
              mt: 0.75,
              // FIXES THE SHORT DROPDOWN / SCROLL ISSUE
              maxHeight: "none !important", // Removes MUI's restricted height constraint
              overflowY: "visible !important", // Forces the list items to render fully without a scrollbar
            },
          },
        }}
        disableScrollLock={true}
        disablePortal={true}
        disableAutoFocus={true}
        disableEnforceFocus={true}
        MenuListProps={{
          autoFocusItem: false,
        }}
      >
        {items.map(renderMenuItem)}
      </Menu>
    </Box>
  );
};

export default APMenuButton;
